<div modalHeader class="modal-header py-2">
  <h2 class="my-1"><b [innerText]="title"></b></h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <form [formGroup]="form" class="pb-8">
    <!-- LOCATION NAME -->
    <div class="form-group">
      <label for="location-name" class="control-label">Location name*</label>
      <input
        id="location-name"
        type="text"
        class="form-control"
        formControlName="name"
        placeholder="Enter location name"
      />
      <control-messages [control]="locationNameControl"></control-messages>
    </div>

    <!-- BUSINESS URL -->
    <div class="form-group">
      <label for="business-url" class="control-label">Business url*</label>
      <input
        id="business-url"
        type="text"
        class="form-control"
        formControlName="publicUrl"
        placeholder="Enter business url"
        maxlength="12"
      />
      <p>Must be 12 or fewer characters and include only lowercase letters, numbers, and - or _ symbols.</p>
      <control-messages [control]="publicUrlControl"></control-messages>
    </div>

    <!-- WEBSITE URL -->
    <div class="form-group">
      <label for="website-url" class="control-label">Website url</label>
      <input
        id="website-url"
        type="text"
        class="form-control"
        formControlName="websiteUrl"
        placeholder="http:// or https://"
        maxlength="50"
      />
      <control-messages [control]="websiteUrlControl"></control-messages>
    </div>

    <div class="row">
      <!-- COUNTRY -->
      <div class="col form-group">
        <label class="control-label">Country*</label>
        <frontend-dropdown
          elementId="country"
          formControlName="country"
          bindLabel="name"
          bindValue="abbr"
          maxListHeight="17rem"
          (ngModelChange)="changeCountry()"
          [items]="countries"
        ></frontend-dropdown>
        <control-messages [control]="countryControl"></control-messages>
      </div>

      <!-- TIMEZONE -->
      <div class="col form-group">
        <label class="control-label">Timezone*</label>
        <frontend-dropdown-plain
          elementId="timezone"
          name="timezone"
          formControlName="timezone"
          maxListHeight="17rem"
          [items]="timezones"
        ></frontend-dropdown-plain>
        <control-messages [control]="timezoneControl"></control-messages>
      </div>
    </div>

    <div class="row">
      <!-- ADDRESS 1 -->
      <div class="col form-group address-width">
        <label class="control-label">Address 1*</label>
        <div *ngIf="userCountry$ | async as country">
          <frontend-google-places
            id="primary-address"
            addressType="address"
            placeholder="Address 1"
            formControlName="primaryAddress"
            [country]="country"
            [initialValueValidated]="!isEditMode"
            (appliedCoords)="applyCoords($event)"
            (address)="applyAddress($event)"
          ></frontend-google-places>
          <control-messages [control]="form.get('primaryAddress')"></control-messages>
        </div>
      </div>

      <!-- ADDRESS 2 -->
      <div class="col form-group address-width">
        <label class="control-label">Address 2</label>
        <span *ngIf="userCountry$ | async as country">
          <frontend-google-places
            id="additional-address"
            addressType="address"
            placeholder="Address 2"
            formControlName="additionalAddress"
            [country]="country"
            [validateAddress]="false"
          ></frontend-google-places>
          <control-messages [control]="form.get('additionalAddress')"></control-messages>
        </span>
      </div>
    </div>

    <div class="row">
      <!-- CITY -->
      <div class="col form-group">
        <label for="city" class="control-label">City*</label>
        <input
          id="city"
          type="text"
          class="form-control"
          formControlName="city"
          placeholder="Enter city"
        />
        <control-messages [control]="cityControl"></control-messages>
      </div>

      <!-- STATE/REGION -->
      <div class="col form-group">
        <label for="state" class="control-label">State/Region*</label>
        <input
          id="state"
          type="text"
          class="form-control"
          formControlName="state"
          placeholder="Enter state"
        />
        <control-messages [control]="stateControl"></control-messages>
      </div>
    </div>

    <div class="row">
      <!-- ZIP/POSTAL CODE -->
      <div class="col form-group">
        <label for="zip" class="control-label">Zip/Postal code*</label>
        <input
          id="zip"
          type="text"
          class="form-control"
          formControlName="postalCode"
          placeholder="Enter zip code"
        />
        <control-messages [control]="postalCodeControl"></control-messages>
      </div>

      <!--PHONE NUMBER -->
      <div class="col form-group" *ngIf="userCountry$ | async as userCountry">
        <label for="business-phone" class="control-label">Business phone*</label>
        <input
          id="business-phone"
          phoneInput
          [countryAbbr]="userCountry"
          type="text"
          class="form-control"
          formControlName="phoneNumber"
          placeholder="Enter phone number"
          pattern="[\-+\(\)\s\d]*"
        />
        <control-messages [control]="phoneNumberControl"></control-messages>
      </div>
    </div>
  </form>
</div>

<div modalFooter class="row p-3">
  <div class="col">
    <button
      class="btn btn-info w-100"
      (click)="submit()"
      angularticsCategory="location"
      angulartics2On="click"
      angularticsAction="{{title}}"
      angularticsProperties="{category: 'location', gtmCustom: { accountName: '{{account.name}}' }}"
    >Save changes</button>
  </div>

  <div class="col">
    <button class="btn btn-danger w-100" (click)="close()">Cancel</button>
  </div>
</div>
